// extracted by mini-css-extract-plugin
module.exports = {"text-container":"VideoText_text-container__Zuz19","description":"VideoText_description__BlFnS","video-button":"VideoText_video-button__wALw0"};